import { createContext, FC, PropsWithChildren, useCallback, useEffect, useState } from "react";
import { UserLocation } from "../@types/UserLocation";

interface GeolocationContextProps {

    userLocation: UserLocation | undefined;

}

export const GeolocationContext = createContext<GeolocationContextProps | undefined>(undefined);

export const GeolocationProvider: FC<PropsWithChildren> = ({ children }) => {

    const [userLocation, setUserLocation] = useState<UserLocation | undefined>(undefined);

    const fetchUserLocation = useCallback(async() => {

        try {

            // Using ipapi.co to get IP and location details
            const response = await fetch('https://geolocation-db.com/json/');

            if (!response.ok) 
                throw new Error(`Error Geolocation! Status: ${response.status}`);

            const data = await response.json();

            setUserLocation(data as UserLocation);

        } catch (error) {

            console.log(`Error geolocating user for location specific content...`);

        }

    }, [setUserLocation]);

    useEffect(() => { fetchUserLocation() }, [fetchUserLocation])

    return (

        <GeolocationContext.Provider value={{ userLocation }}>

            {children}

        </GeolocationContext.Provider>

    )

}